import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const apiExternal = createApi({
  reducerPath: "apiExternal",
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_URL_EXTERNAL,
  }),
  endpoints: (builder) => ({
    // getting bench locations
    getBenchLocations: builder.mutation({
      query: () => ({
        url: "getBenchLocations",
        method: "POST",
      }),
    }),
    /* Case Management System */
    // Cause List
    getCourtNumbers: builder.mutation({
      query: (payload) => ({
        url: "getCourtNos",
        method: "POST",
        body: payload,
      }),
    }),
    submitCauseList: builder.mutation({
      query: (payload) => ({
        url: "public_causelist",
        method: "POST",
        body: payload,
      }),
    }),
    // Case Status
    sendCaptcha: builder.mutation({
      query: (payload) => ({
        url: "updateCaptcha",
        method: "POST",
        body: payload,
      }),
    }),
    getApplicationTypes: builder.mutation({
      query: (payload) => ({
        url: "getApplicationTypes",
        method: "POST",
        body: payload,
      }),
    }),
    submitCaseStatus: builder.mutation({
      query: (payload) => ({
        url: "getCaseDetailsPublic",
        method: "POST",
        body: payload,
      }),
    }),
    getDocumentBacklogList: builder.mutation({
      query: (payload) => ({
        url: "getDocumentBacklogList",
        method: "POST",
        body: payload,
      }),
    }),
    getProceedingBacklogList: builder.mutation({
      query: (payload) => ({
        url: "getProceedingBacklogList",
        method: "POST",
        body: payload,
      }),
    }),
  }),
});

export const {
  useGetBenchLocationsMutation,
  useGetCourtNumbersMutation,
  useSubmitCauseListMutation,
  useSendCaptchaMutation,
  useGetApplicationTypesMutation,
  useSubmitCaseStatusMutation,
  useGetDocumentBacklogListMutation,
  useGetProceedingBacklogListMutation,
} = apiExternal;
